import { IApplicationState } from '../types/redux';

export const selectUserGeo = (state: IApplicationState) => state.userGeo.userGeo;
